import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-446b956d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "uq-preloader"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader loader--3" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "container auth-container"
}
const _hoisted_5 = { class: "container-form py-56 px-32 px-sm-56" }
const _hoisted_6 = { class: "h4 title mb-36 mb-sm-56 text-primary" }
const _hoisted_7 = {
  class: "invalid-feedback text-danger text-start",
  role: "alert"
}
const _hoisted_8 = {
  class: "invalid-feedback text-start",
  role: "alert"
}
const _hoisted_9 = { class: "user-info" }
const _hoisted_10 = {
  key: 0,
  class: "user-info text-primary mt-16"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-box-refresh-alt-right me-12",
  "aria-hidden": "true"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_form_group_input_text = _resolveComponent("v-form-group-input-text")!
  const _component_v_button = _resolveComponent("v-button")!

  return (_ctx.status === 'loading')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.$t('Reestablecer contraseña')), 1),
          _createElementVNode("form", {
            id: "login",
            onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.forgotPassword && _ctx.forgotPassword(...args)), ["prevent"]))
          }, [
            _createVNode(_component_v_form_group_input_text, {
              type: "email",
              class: "mb-40",
              "input-class": {'is-invalid': !!_ctx.apiErrors},
              value: _ctx.email,
              label: _ctx.$t('Introduce tu correo'),
              "yup-errors-variable": _ctx.errors.email,
              autocomplete: "off",
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_ctx.email = $event))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.apiErrors.email, (error, index) => {
                    return (_openBlock(), _createElementBlock("p", {
                      class: "mb-0",
                      key: index
                    }, _toDisplayString(error), 1))
                  }), 128))
                ])
              ]),
              _: 1
            }, 8, ["input-class", "value", "label", "yup-errors-variable"]),
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.apiErrors.email, (error, index) => {
                return (_openBlock(), _createElementBlock("p", {
                  class: "mb-0",
                  key: index
                }, _toDisplayString(error), 1))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_9, _toDisplayString(// eslint-disable-next-line max-len
            _ctx.$t('Te enviaremos un correo electrónico con un enlace para que puedas generar una nueva contraseña. Si no lo recibes revisa la carpeta de spam.')), 1),
            (_ctx.mailSent)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.$t('Te acabamos de reenviar el correo, revisa tu carpeta de spam por si acaso.')), 1))
              : _createCommentVNode("", true),
            _createVNode(_component_v_button, {
              type: "submit",
              variant: "secondary",
              class: "btn-icon mt-40",
              "aria-label": _ctx.$t('Reestablecer contraseña'),
              disabled: !_ctx.meta.valid || _ctx.accepted,
              "is-loading": _ctx.accepted
            }, {
              default: _withCtx(() => [
                _hoisted_11,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('Reestablecer contraseña')), 1)
              ]),
              _: 1
            }, 8, ["aria-label", "disabled", "is-loading"])
          ], 32)
        ])
      ]))
}